module.exports = __webpack_public_path__ + "static/profile-pic-f4c58bb9bb64eda1f38d763610eb15e3.jpg";